import React, { useContext } from "react";
import { Container, Row, Col, Card, CardBody, Button, CardImg } from "reactstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faChalkboardTeacher,
//   faCertificate,
//   faBook,
//   faCalendarAlt,
//   faGlobe,
//   faUsers,
// } from "@fortawesome/free-solid-svg-icons";
import { CommonContext } from "../../context";
import { Link } from "react-router-dom";

const Explore = () => {
  const { indexData } = useContext(CommonContext);

  return (
    <section className="course-categories">
      <Container>
        <div class="align-items-center mb-4 row">
          <div class="col-md-12">
            <h2 class="title" style={{ textAlign: "center" }}>Know Institution Of Valuers</h2>
            <div class="d-flex align-items-center">
              <div class="line"></div>
              <p class="newsletter-text text-white mt-1">
                A Pioneer Organisation in Valuation Profession, IOV assists and
                guides general public, government and semi-government bodies in
                adjudicating valuation-related disputes through its Experts
                Council, certifying valuation professionals and developing
                valuation standards 
                {/* <Button className="btn-grad">Read More</Button> */}
              </p>
            </div>{" "}
            <h2 class="newsletter-title text-white mt-4" style={{ textAlign: "center" }}>
              IOV Caters to The <span class="highlight">Valuers Through</span>
            </h2>
          </div>
        </div>
        {/* <Row className="align-items-center mb-4">
          <Col md="12" className="text-center">
            <h2 className="title">
              Explore Top Seminar <span className="highlight">Categories</span>
            </h2>
            <p className="top-text">
              IOV IMPARTS, ENCOURAGES AND ARRANGES FOR TRAINING OF THE VALUATION AND SEMINAR WORK OF ALL TYPES.
            </p>
          </Col>
        </Row> */}
        <Row className="category-row">
          {indexData && indexData?.home_cards?.length > 0 && indexData?.home_cards.map((category, index) => (
            <Col key={index} md="4" className="category-col">
              <Card className="category-card">
                <CardBody className="text-center">
                  <div className="icon-wrapper">
                    {/* <FontAwesomeIcon
                      icon={category?.icon}
                      className="category-icon"
                    /> */}
                    {/* <i className={category?.icon} aria-hidden="true"></i> */}
                    <CardImg
                      top
                      width="100%"
                      src={
                        category.icon
                          ? `${process.env.REACT_APP_BASE_URL}download/${category?.icon}?pathName=cards`
                          : "https://via.placeholder.com/150"
                      }
                      alt="icon"
                    />
                  </div>
                  <h3 className="category-title">{category?.title}</h3>
                  <p className="category-description">{category?.small_desc}</p>
                  <div className="btn-wrapper">
                    <Link className="btn-grad" to={category?.read_more_link}>
                      Read More
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Explore;
